export enum ApplicationStatus {
  Draft = 1,
  Submitted = 2,
  UnderReview = 3,
  Approved = 4,
  Rejected = 5,
  Cancelled = 6
}
